import React, { useState, useEffect } from "react";
import { Box, Button, CircularProgress, Grid2, Typography } from "@mui/material";
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from "../firebase/firebaseConfig";
import ListaCancionesWeb from "../elements/pages/Main/ListaCancionesWeb";

const MiMusica = () => {
    const [miMusica, setMiMusica] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    const truncateText = (text, maxLength = 200) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    }

    useEffect(() => {
        onSnapshot(collection(db, 'infoMiMusicaWebcalocho'),
            (snapshot) => {
                const arregloMiMusica = snapshot.docs.map((docMiMusica) => {
                    return { ...docMiMusica.data(), id: docMiMusica.id };
                })
                setMiMusica(arregloMiMusica);
                setLoading(false); // Even if there's an error, stop loading
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    // Carrusel: Actualizar el índice cada 10 segundos
    useEffect(() => {
        if (miMusica.length > 1) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % miMusica.length);
            }, 10000); // 10000ms = 10s
            return () => clearInterval(interval);
        }
    }, [miMusica.length]);


    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress sx={{ color: '#5d0303' }} />
            </Box>
            );
        }

        if (miMusica.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography variant="h6">No hay datos por mostrar</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ 
            backgroundColor: '#0a1f44', 
            color: '#fff',
            backgroundImage: 'linear-gradient(180deg, #5d0303, #8E0505)',
            display: 'flex',
            flexDirection: { xs: 'column-reverse', md: 'row-reverse' },
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: 'auto',
            padding: { xs: 2, md: 4 },
        }}>
            <ListaCancionesWeb />

                <Grid2 key={miMusica[currentIndex].id} sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: { xs: '100%', sm: '80%', md: '60%' },
                    padding: { xs: 2, sm: 3 },
                    textAlign: 'center',
                    marginBottom: { xs: 2, md: 0 },
                }}>
                    <Typography variant="h3" sx={{
                        fontWeight: 'bold',
                        fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                        margin: { xs: '12px 0', sm: '18px 0' },
                        textAlign: 'center',
                    }}>
                        {miMusica[currentIndex].titulo}
                    </Typography>

                    <Typography variant="h5" sx={{
                        fontSize: { xs: '1rem', sm: '1.2rem' },
                        margin: { xs: '10px 0', sm: '15px 0' },
                        textAlign: 'center',
                    }}>
                        {miMusica[currentIndex].subtitulo}
                    </Typography>

                    <Typography variant="body1" sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                        margin: { xs: '8px 0', sm: '12px 0' },
                        textAlign: 'center',
                    }}>
                        <span>{truncateText(miMusica[currentIndex].descripcion)}</span>
                    </Typography>

                    <Button
                        variant="outlined"
                        size="small"
                        sx={{
                            width: { xs: '80%', sm: '60%', md: '50%' },
                            alignSelf: 'center',
                            color: '#f9f9f9',
                            background: '#8E0505',
                            borderColor: '#f9f9f9',
                            mt: 2,
                            ':hover': {
                                backgroundColor: '#ff6f61',
                                borderColor: '#f9f9f9',
                            },
                        }}
                    >
                        Ver más
                    </Button>
                </Grid2>
        </Box>
    );
}

export default MiMusica;